import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import type { InputOf } from "../../useMbcAdminMutation";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { assignGuideline } from "../api";

export function useAssignGuideline(): UseMutationResult<
  void,
  Error,
  InputOf<typeof assignGuideline>
> {
  return useMbcAdminMutation(assignGuideline, mbcAdminKeys.assignments());
}
